import { Filter } from "../../..//libs/store/filters";
import { DateRangeSelector } from "../../atoms/inputs";
import { ReactNode } from "react";
import { Dayjs } from "dayjs";
import { FormattedMessage, useIntl } from "react-intl";
import { Stack, Typography } from "@mui/material";
import { dateRangeShortcuts } from "../../../libs/models/common";

type StartDateRangeFilterInputControlledProps = {
  onClear: () => void;
  onSetFilter: (filter: Filter) => void;
  dateLabel: string;
  label?: ReactNode;
  dateValue:
    | {
        from: Dayjs;
        to: Dayjs;
      }
    | undefined;
  disabled?: boolean;
  timezone: string;
  loading?: boolean;
};
export function StartDateRangeFilterInputControlled({
  onClear,
  onSetFilter,
  dateLabel,
  dateValue,
  timezone,
  loading,
  disabled = false,
  label,
}: StartDateRangeFilterInputControlledProps) {
  const intl = useIntl();

  return (
    <DateRangeSelector
      onAccept={(v) => {
        if (!v[0] && !v[1]) {
          onClear && onClear();
          return;
        }

        // Handle single date selection by using the same date for both from and to
        const fromDate = v[0] || v[1];
        let toDate = v[1] || v[0];

        // Ensure we have valid dates before setting the filter
        if (!fromDate || !toDate) {
          onClear && onClear();
          return;
        }

        onSetFilter({
          key: '',
          value: {
            timezone,
            from: fromDate,
            to: toDate,
          },
        });
      }}
      disabled={disabled || loading}
      fullWidth
      label={
        <Stack direction="row">
          <Typography variant="body1" color="text.secondary" sx={{ flexShrink: 0 }}>
            {label ?? <FormattedMessage id="shifts.fields.startDate" />}
            &nbsp;
          </Typography>
          <Typography variant="body1" color="text.primary" noWrap title={dateLabel}>
            {dateLabel || <FormattedMessage id="shifts.startDateAll" />}
          </Typography>
        </Stack>
      }
      shortcutsItems={dateRangeShortcuts.map(({ labelKey, ...sh }) => ({
        ...sh,
        label: intl.formatMessage({ id: labelKey }),
      }))}
      value={[dateValue?.from ?? null, dateValue?.to ?? null]}
    />
  );
}
